import { useTheme, Stack } from "@mui/material";
import { ActionFieldQuestions } from "./ActionFieldQuestions/ActionFieldQuestions";
import { ActionPrecisionQuestions } from "./ActionPrecisionQuestions/ActionPrecisionQuestions";
import { ActionField } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { isSomeStartingDataInsufficient } from "../ImpactSection/utils";
import { InsufficientDataMessage } from "./InsufficientDataMessage";
import { useMyActionPlanContext } from "../../context/useMyActionPlan";
import { ImpactSectionDrawer } from "../ImpactSection/ImpactSectionDrawer/ImpactSectionDrawer";
import { ActionViolationErrorsModal } from "src/components/Actions/Tabs/ActionViolationErrorsModal/ActionViolationErrorsModal";
import { useActionsContext } from "src/context/Actions/useActionsContext";

export const ActionCalculationFields = () => {
    const theme = useTheme();
    const { actionPlanAction } = useMyActionPlanContext();
    const { actionPlan, isValidationModalOpen, validationMessages, lastSelectedVariation, setIsValidationModalOpen } =
        useActionsContext();

    // Extract action fields from the action data
    const actionFields: ActionField[] = actionPlanAction.action?.actionFields || [];
    const isSomeDataInsufficient = isSomeStartingDataInsufficient(actionFields, actionPlanAction);

    if (actionPlan === null) {
        return null;
    }

    return (
        <Stack
            gap={3}
            sx={{
                padding: theme.spacing(3),
                backgroundColor: "#FFFFFF",
                borderRadius: "12px",
                border: `1px solid ${theme.custom.grey[400] || "#E7E6E4"}`,
                boxShadow: "0px 2px 8px 0px rgba(42, 43, 39, 0.04)",
            }}
        >
            {isSomeDataInsufficient && <InsufficientDataMessage />}

            <ActionPrecisionQuestions />
            <ActionFieldQuestions actionFields={actionFields} />

            <ImpactSectionDrawer />
            <ActionViolationErrorsModal
                isOpen={isValidationModalOpen}
                onClose={() => setIsValidationModalOpen(false)}
                validationMessages={validationMessages}
                actionPlan={actionPlan}
                scoreId={lastSelectedVariation.scoreId}
            />
        </Stack>
    );
};
